export enum TeamType {
    TEAM_1 = 1,
    TEAM_2 = 2,
    TEAM_3 = 3,
    TEAM_4 = 4,
    TEAM_5 = 5,
    TEAM_6 = 6,
    TEAM_7 = 7,
    TEAM_8 = 8,
    TEAM_9 = 9,
    TEAM_10 = 10,
    TRITATHLON_TEAM_3 = 11
}
